export enum Degree {
  HighSchool = "Bachillerato",
  UniversityStudent = "Estudiante universitario",
  BachelorComplete = "Licenciatura completa",
  Graduated = "Titulado",
  Masters = "Maestría",
  Doctorate = "Doctorado",
  Other = "Otros",
}
